<div class="modal-header">
  <h4 class="modal-title pull-left">{{'ORTHOPHOTOS.ORTHOPHOTOS' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form id="myForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="nomOrthophoto">{{'ORTHOPHOTOS.NOM' | translate}}</label>
      <input id="nomOrthophoto" type="text" [(ngModel)]="orthophotoTemp.name" name="nomOrthophoto" class="form-control" placeholder="{{'ORTHOPHOTOS.NOM' | translate}}" maxlength="256" autocomplete="off" [readonly]="!upload" />
      @if (nomInvalide) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
      }
    </div>
    <div class="form-group">
      <label for="selectIsActif">{{'GLOBAL.ACTIF' | translate}}</label>
      <button type="button" name="selectIsActif" btnCheckbox class="toggle-btn" [ngClass]="orthophotoTemp.isActif === true ? 'btn-success':'btn-danger'" [(ngModel)]="orthophotoTemp.isActif">
        {{orthophotoTemp.isActif ? ('GLOBAL.OUI' | translate) : ('GLOBAL.NON' | translate)}}
      </button>
    </div>
    <div class="form-group">
      <label id="ordre">{{'ORTHOPHOTOS.ORDRE' | translate}}</label>
      <input id="ordre" type="number" [(ngModel)]="orthophotoTemp.ordre" name="ordre" class="form-control" placeholder="{{'ORTHOPHOTOS.ORDRE' | translate}}" maxlength="256" autocomplete="off" />
      @if (ordreInvalide) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
      }
    </div>
    <div class="form-group">
      @if (fichierTelechargement) {
        <label class="nom-fichier">{{fichierTelechargement.name}} - {{fichierTelechargement.size | formatFileSize}}</label>
        <button type="button" class="close pull-right" aria-label="Close" (click)="enleverFichier()" title="{{'ORTHOPHOTOS.SUPPRIMER' | translate}}">
          <span aria-hidden="true">&times;</span>
        </button>
      }
      <input type="file" id="inputFile" style="display:none;" />
      @if (!fichierTelechargement && upload) {
        <button type="button" class="btn btn-primary" (click)="ouvrirExplorateur()">{{ 'ORTHOPHOTOS.SELECTIONNEZ_FICHIERS' | translate }}</button>
      }
      @if (erreurExtension) {
        <div class="custom-alert custom-alert-sm" id="erreur_extension">{{ 'ORTHOPHOTOS.ERREUR_EXTENSION' | translate }}</div>
      }
      @if (fichierNonSelectionne) {
        <div class="custom-alert custom-alert-sm">{{ 'GLOBAL.CHAMP_OBLIGATOIRE' | translate }}</div>
      }
    </div>
    <div class="btn-toolbar justify-content-between">
      <div class="btn-group" role="group">
        <button type="submit" class="btn btn-outline-success" style="margin-right:10px;">{{'GLOBAL.VALIDER' | translate}}</button>
        @if (!upload) {
          <button type="button" class="btn btn-danger" (click)="showConfirmSuppr()">{{'GLOBAL.SUPPRIMER' | translate}}</button>
        }
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
      </div>
    </div>
  </form>
</div>

<div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.SUPPRIMER' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="deleteLayer()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideConfirmSuppr()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="bsModalRef.hide()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideModalCancel()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>
